import AuthLayout from '../../components/layout/AuthLayout.jsx';
import BaseError from '../../components/misc/BaseError.jsx';
import { HTTP_FORBIDDEN } from '../../utils/constants.js';

const PageNotAllowed = () => {
    return (
        <AuthLayout title='Forbidden' mainClassNames={'content-center'}>
            <div className='max-w-3xl w-full mx-auto px-4'>
                <BaseError status={HTTP_FORBIDDEN} statusText='Not allowed' />
            </div>
        </AuthLayout>
    );
};

export default PageNotAllowed;
